<div>
  <div class="flex gap-[5px] items-center mt-[0px]">
    <div
      class="flex flex-row relative mt-[3px] bg-[#ffffff] rounded-full p-[5px] md:w-[140px] w-[115px] md:h-[42px] h-[42px] border-gray-300 border-solid border-[2px] items-center justify-center mb-[10px] md:mb-[0px]"
    >
      <button
        (click)="
          quantityChange(slot?.widget?.data?.value?.decreaseQuantity?.action)
        "
        class="bg-[#FFFFFF] flex items-center justify-center border-[#dfdfdf] border-solid border-[1px] text-gray-700 hover:text-[#fff] hover:bg-[#ff0000] rounded-full cursor-pointer outline-none md:w-[30px] w-[30px] md:h-[30px] h-[30px] shadow-sm hover:shadow-lg transition-all"
      >
        <span class="text-2xl text-[20px] leading-[20px]">-</span>
      </button>
      <input
        [(ngModel)]="quantity"
        type="tel"
        inputmode="numeric"
        name="custom-input-number"
        class="qty-input text-center w-[45px] md:w-[65px] bg-transparent h-[35px] font-semibold text-md flex items-center text-gray-700 border-hidden ng-untouched ng-pristine ng-valid"
        min="1"
        step="1"
        (change)="quantityChangeManually($event, slot?.widget?.data?.action)"
        autocomplete="new-password"
      />
      <button
        (click)="
          quantityChange(slot?.widget?.data?.value?.increaseQuantity?.action)
        "
        [ngClass]="{
          'hover:bg-[#ff0000] hover:text-[#fff] hover:shadow-lg cursor-pointer':
            slot?.widget?.data?.value?.increaseQuantity?.action,
          'cursor-not-allowed opacity-[0.3]':
            !slot?.widget?.data?.value?.increaseQuantity?.action,
        }"
        class="bg-[#FFFFFF] flex items-center justify-center border-[#dfdfdf] border-solid border-[1px] text-gray-700 rounded-full cursor-pointer outline-none md:w-[30px] w-[30px] md:h-[30px] h-[30px] shadow-sm transition-all"
      >
        <span class="m-auto text-2xl text-[20px] leading-[20px]">+</span>
      </button>
    </div>
    <div class="text-[12px]">
      Minimum Order Quantity- {{ slot?.widget?.data?.value?.moq }}
    </div>
  </div>
  @if (slot?.widget?.data?.value?.message) {
    <div
      class="text-[12px] text-[#945700] bg-[#fef7e0] rounded-[10px] p-[10px] mt-[10px]"
    >
      <span>{{ slot?.widget?.data?.value?.message }}</span>
    </div>
  }
</div>
